import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageSkeleton } from "../../components/accommodation/page-skeleton";
import { type EntriesSearch, EntriesPage, entriesSearchSchema } from "../../components/entries/entries-page";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canSeeEntries } from "../../lib/entries/access";

/**
 * Sport entries (M7b) — Entry by number. Same page and URL state as the
 * Expression of interest route; only the phase differs.
 */
export const Route = createFileRoute("/_app/accreditation/entries/ebn")({
	beforeLoad: ({ context }) => {
		if (!canSeeEntries(context.session)) throw redirect({ to: "/" });
	},
	validateSearch: entriesSearchSchema,
	// "full": the admin NOC table is wide; the NOC editor caps itself to the page width (entries-page.tsx).
	staticData: { contentTop: "tabbed", contentWidth: "full" },
	component: Page,
});

function Page() {
	const search = Route.useSearch() as EntriesSearch;
	const navigate = Route.useNavigate();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId) return <PageSkeleton />;
	return (
		<EntriesPage
			key={`${gamesId}|${search.org ?? ""}`}
			phase="EBN"
			gamesId={gamesId}
			search={search}
			patch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }), replace: true })}
		/>
	);
}
